export default __webpack_public_path__ + "static/media/File.f354a841.svg";